import { useContext } from "react";

import ProposalInputContext from "../../../context/ProposalInputContext";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

import FileDropZone from "../../layout/FileDropZone";

const InputHeader = () => {
  const {
    formErrors, file, setFile, setApiRes,
  } = useContext(ProposalInputContext);

  return (
    <>
      <Grid
        size={{ xs: 12 }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        <Typography
          variant="h5"
          sx={{ color: '#1e293b' }}
        >
          <strong>Proposal Inputs</strong>
        </Typography>

        <Typography
          color="text.secondary"
        >
          Upload a document or fill out the sections below to generate your proposal.
        </Typography>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <FileDropZone
          file={file}
          setFile={setFile}
          setApiRes={setApiRes}
          formErrors={formErrors}
        />
      </Grid>

      <Divider
        sx={{
          width: '100%',
          borderColor: '#e2e8f0',
          borderBottomWidth: '2px',
          my: 1,
        }}
      >
        <Typography color="text.secondary">
          <strong>OR FILL MANUALLY</strong>
        </Typography>
      </Divider>
    </>
  );
};

export default InputHeader;